import { render, staticRenderFns } from "./agendamento-medicina.vue?vue&type=template&id=da5ec72e"
import script from "./agendamento-medicina.vue?vue&type=script&lang=js"
export * from "./agendamento-medicina.vue?vue&type=script&lang=js"
import style0 from "./agendamento-medicina.vue?vue&type=style&index=0&id=da5ec72e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports